import { apiFetch } from './client';

export interface DownloadEntry {
  filename: string;
  platform: string;
  arch: string;
  icon: string;
  url: string;
}

export async function getDownloads(token: string): Promise<DownloadEntry[]> {
  const data = await apiFetch<{ downloads: DownloadEntry[] }>('/api/mgmt/downloads', token);
  return data.downloads ?? [];
}
